<template lang="pug">
  .selectorLabel
    |{{label}}
    .selectorLabel_ageStandardized(v-if="hasageStandardizedWord")
      |{{ageStandardizedLabel}}

  //
</template>

<script>
  import {mapState} from 'vuex';
  import _ from 'lodash';

export default {
  name: "selectorLabel",
  props: ['option', 'is_ja'],
  computed: {
    ...mapState([
      'lang',
      'ageStandardizedWord',
    ]),
    label(){
      return this.is_ja ? this.option.name : this.option.label;
    },
    hasageStandardizedWord(){
      return _.isBoolean(this.option.ageStandardized);
    },
    ageStandardizedLabel(){
      if(this.hasageStandardizedWord) {
        if (this.option.ageStandardized) {
          return this.ageStandardizedWord[this.lang][0];
        } else {
          return this.ageStandardizedWord[this.lang][1];
        }
      }
      return ''
    },
  },
}
</script>

<style lang="sass" scoped>
  .selectorLabel
    font-size: 16px
    &_ageStandardized
      font-size: 14px
      display: inline-block
      margin-left: 1ex

</style>